<div class="page-container">

  <div class="articles-page container">
    <mat-card *ngFor="let article of articles |  sort: 'createdAt' : true;">
      <mat-card-content>
        <article-preview [article]="article"></article-preview>
      </mat-card-content>
    </mat-card>

  </div>


</div>
